module.exports = __webpack_public_path__ + "img/technical_support_04.2efc17d0.png";